// extracted by mini-css-extract-plugin
export default {"content":"mZwmyd","buttons":"J1m8jV","title":"xTa8V9","text":"fIJw0k","publisher":"m7TkUu","overlay":"nJUgRX"};